import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { addData } from "../../helpers/fackBackend_Helper";

function* getActivationStatusRequest({ payload }) {
    try {
        console.log("PAYLOAD:", payload);

        const searchData = {
            serialNumber: payload.serialNumber
        };

        const response = yield call(
            addData,
            "/activationStatus",
            searchData
        );

        console.log("API RESPONSE:", response);

        if (
            response &&
            response.response &&
            response.response.Status === 1 &&
            Array.isArray(response.response.data)
        ) {
            yield put(
                actions.getActivationStatusSuccess(
                    response.response.data
                )
            );
        } else {
            yield put(
                actions.getActivationStatusFailure(
                    response?.response?.Message ||
                    "No activation status found"
                )
            );
        }

    } catch (error) {

        console.error("API ERROR:", error);

        yield put(
            actions.getActivationStatusFailure(
                error.message || "Something went wrong"
            )
        );
    }
}

function* activationStatusSaga() {
    yield takeEvery(
        actions.GET_ACTIVATION_STATUS,
        getActivationStatusRequest
    );
}

export default function* rootSaga() {
    yield all([
        activationStatusSaga()
    ]);
}